module.exports = __webpack_public_path__ + "static/media/AB_O1_11.34d17b4d.jpg";